// Lightweight logger utility
// - debug/info/warn emit only in development builds
// - error always emits

const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development';

const emit = (fn, ...args) => {
  try { fn(...args); } catch (_) { /* noop */ }
};

const log = {
  debug: (...args) => { if (isDev) emit(console.log, ...args); },
  info: (...args) => { if (isDev) emit(console.log, ...args); },
  warn: (...args) => { if (isDev) emit(console.warn, ...args); },
  error: (...args) => emit(console.error, ...args),
};

export default log;
export const logger = log;


